<template>
  <el-dialog
    :visible="true"
    :fullscreen="true"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div slot="title">
      <span v-if="type === 'add'">Új számla</span>
      <span v-if="type === 'update'">Számla módosítása</span>
      <span v-if="type === 'view'">Számla megtekintése</span>
      <el-tag
        v-if="invoice.status && (type === 'update' || type === 'view')"
        size="small"
        :type="getStatus().tag"
        style="margin-left: 5px;"
      >
        {{ getStatus().label }}
      </el-tag>
    </div>
    <div v-if="type === 'view' && invoice.invoice_file && invoice.status !== 'recorded'">
      <el-link @click="openInvoice" type="primary" style="margin-bottom: 30px; margin-top: -20px;">
        <i class="el-icon-printer el-icon--right"></i>
        {{ invoice.invoice_number }}
      </el-link>
    </div>
    <div v-loading="loading || actionLoading">
      <el-form
        ref="invoiceForm"
        label-position="top"
        :model="invoice"
        :rules="formRules"
      >
        <el-switch
          v-model="hasDelivery"
          active-text="Csak számlázandó szállítólevelekhez tartozó ügyfelek"
          :disabled="invoice.status !== 'recorded' || type === 'view'"
          style="margin-bottom: 30px;"
          @change="onHasDelivery"
        />
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              prop="invoice_book"
              label="Számlatömb"
            >
              <el-select
                v-model="invoice.invoice_book"
                style="width: 100%;"
                value-key="id"
                filterable
                :disabled="invoice.status !== 'recorded' || type === 'view'"
                @change="onInvoiceBookChange"
              >
                <el-option
                  v-for="invoiceBook in invoiceBooks"
                  :key="invoiceBook.id + 'invoiceBook'"
                  :value="invoiceBook"
                  :label="invoiceBook.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="supplier"
              label="Eladó"
            >
              <el-select
                v-model="invoice.supplier"
                style="width: 100%;"
                value-key="id"
                filterable
                :disabled="invoice.status !== 'recorded' || type === 'view'"
              >
                <el-option
                  v-for="supplier in suppliers"
                  :key="supplier.id + 'supplier'"
                  :value="supplier"
                  :label="supplier.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="customer"
              label="Vevő"
            >
              <el-select
                v-if="!hasDelivery"
                v-model="invoice.customer"
                filterable
                remote
                :remote-method="searchPartners"
                :loading="partnerLoading"
                :disabled="invoice.status !== 'recorded' || type === 'view'"
                placeholder="Írd be a partner nevét a kereséshez..."
                style="width: 100%;"
                value-key="id"
                @change="onCustomerChange"
              >
                <el-option
                  v-for="customer in customers"
                  :key="getKey()"
                  :value="customer"
                  :label="`#${customer.id} ${customer.company.name}`"
                >
                  <span style="float: left; margin-right: 30px;">
                    {{ `#${customer.id} ${customer.company.name}` }}
                  </span>
                  <span style="float: right; color: #8492a6; font-size: 13px;">
                    <el-tag
                      v-if="customer.customer_sales_count || customer.representative_sales_count || customer.customer_return_orders_count"
                      size="mini" type="primary">{{ customer.customer_sales_count + customer.representative_sales_count + customer.customer_return_orders_count }} szállítólevél</el-tag>
                  </span>
                </el-option>
              </el-select>
              <el-select
                v-if="hasDelivery"
                v-model="invoice.customer"
                style="width: 100%;"
                value-key="id"
                filterable
                :disabled="invoice.status !== 'recorded' || type === 'view'"
                @change="onCustomerChange"
              >
                <el-option
                  v-for="customer in customers"

                  :key="getKey()"
                  :value="customer"
                  :label="`#${customer.id} ${customer.company.name}`"
                >
                  <span style="float: left; margin-right: 30px;">
                    {{ `#${customer.id} ${customer.company.name}` }}
                  </span>
                  <span style="float: right; color: #8492a6; font-size: 13px;">
                    <el-tag
                      v-if="customer.customer_sales_count || customer.representative_sales_count || customer.customer_return_orders_count"
                      size="mini" type="primary">{{ customer.customer_sales_count + customer.representative_sales_count + customer.customer_return_orders_count }} szállítólevél</el-tag>
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="customer_address"
              label="Vevő címe"
            >
              <el-select
                v-model="invoice.customer_address"
                v-loading="addressesLoading"
                style="width: 100%;"
                value-key="id"
                filterable
                :disabled="invoice.status !== 'recorded' || addresses.length === 0 || type === 'view'"
              >
                <el-option
                  v-for="address in addresses"
                  :key="address.id + 'address'"
                  :value="address"
                  :label="`${address.full_address}`"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item
              prop="currency"
              label="Deviza"
            >
              <el-select
                v-model="invoice.currency"
                :disabled="invoice.status !== 'recorded' || type === 'view'"
                style="width: 100%;"
                value-key="id"
                filterable
                @change="onCurrencyChange"
              >
                <el-option
                  v-for="currency in currencies"
                  :key="currency.id + 'currency'"
                  :value="currency"
                  :label="currency.name"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            v-if="!isHufInvoice"
            :span="6"
          >
            <el-form-item
              prop="exchange_rate"
              :label="`Árfolyam (1 ${invoice.currency.code} = ? HUF)`"
            >
              <el-input-localized-numeric
                v-model="exchangeRate"
                :disabled="invoice.status !== 'recorded' || type === 'view' || invoice.type !== 'CREATE'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="issue_date"
              label="Kiállítás dátuma"
            >
              <el-date-picker
                v-model="invoice.issue_date"
                type="date"
                :disabled="invoice.status !== 'recorded' || type === 'view'"
                style="width: 100%;"
                :clearable="false"
                format="yyyy. MM. dd."
                value-format="yyyy-MM-dd"
                :picker-options="{ firstDayOfWeek: 1 }"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="delivery_date"
              label="Teljesítés dátuma"
            >
              <el-date-picker
                v-model="invoice.delivery_date"
                type="date"
                :disabled="invoice.status !== 'recorded' || type === 'view'"
                style="width: 100%;"
                :clearable="false"
                format="yyyy. MM. dd."
                value-format="yyyy-MM-dd"
                :picker-options="{ firstDayOfWeek: 1 }"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              prop="payment_date"
              label="Fizetési határidő"
            >
              <el-date-picker
                v-model="invoice.payment_date"
                type="date"
                :disabled="invoice.status !== 'recorded' || type === 'view'"
                style="width: 100%;"
                :clearable="false"
                format="yyyy. MM. dd."
                value-format="yyyy-MM-dd"
                :picker-options="{ firstDayOfWeek: 1 }"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="3">
            <el-form-item
              prop="payment_method"
              label="Számla típus"
            >
              <el-select
                v-model="invoice.is_advance"
                :disabled="invoice.status !== 'recorded' || type === 'view' || invoice.type !== 'CREATE'"
                style="width: 100%;"
                @change="onIsAdvanceChange"
              >
                <el-option
                  :value="false"
                  label="Normál"
                />
                <el-option
                  :value="true"
                  label="Előleg"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item
              prop="payment_method"
              label="Fizetési mód"
            >
              <el-select
                v-model="invoice.payment_method"
                :disabled="invoice.status !== 'recorded' || type === 'view'"
                style="width: 100%;"
              >
                <el-option
                  value="CASH"
                  label="Készpénz"
                />
                <el-option
                  value="TRANSFER"
                  label="Átutalás"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            v-if="(invoice.customer && invoice.customer.customer_sales_count || (customerSales && customerSales.length)) && !invoice.is_advance && invoice.type === 'CREATE'"
            :span="6"
          >
            <el-form-item
              prop="customer_sales"
              label="Központi szállítólevelek (Eladás)"
            >
              <el-select
                v-loading="customerSalesLoading"
                :value="invoice.customer_sales"
                style="width: 100%;"
                value-key="id"
                filterable
                multiple
                :disabled="invoice.status !== 'recorded' || type === 'view'"
                @change="onCustomerSalesChange"
              >
                <el-option
                  v-for="sale in customerSales"
                  :key="sale.id + 'sale'"
                  :value="sale"
                  :label="sale.receipt_number"
                >
                  <span style="float: left; margin-right: 30px;">
                    {{ sale.receipt_number }} <i>(Teljesítés: {{ sale.delivery_date | date }})</i>
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            v-if="(invoice.customer && invoice.customer.customer_return_orders_count || (customerReturnOrders && customerReturnOrders.length)) && !invoice.is_advance && invoice.type === 'CREATE'"
            :span="6"
          >
            <el-form-item
              prop="customer_sales"
              label="Központi szállítólevelek (Visszáru)"
            >
              <el-select
                v-loading="customerSalesLoading"
                :value="invoice.customer_return_orders"
                style="width: 100%;"
                value-key="id"
                filterable
                multiple
                :disabled="invoice.status !== 'recorded' || type === 'view'"
                @change="onCustomerReturnOrdersChange"
              >
                <el-option
                  v-for="sale in customerReturnOrders"
                  :key="sale.id + 'sale'"
                  :value="sale"
                  :label="sale.receipt_number"
                >
                  <span style="float: left; margin-right: 30px;">
                    {{ sale.receipt_number }} <i>(Teljesítés: {{ sale.delivery_date | date }})</i>
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            v-if="(invoice.customer && invoice.customer.representative_sales_count || (representativeSales && representativeSales.length)) && !invoice.is_advance && invoice.type === 'CREATE'"
            :span="6"
          >
            <el-form-item
              prop="representative_sales"
              label="Képviselői szállítólevelek"
            >
              <el-select
                v-loading="customerSalesLoading"
                :value="invoice.representative_sales"
                value-key="id"
                style="width: 100%;"
                filterable
                multiple
                :disabled="invoice.status !== 'recorded' || type === 'view'"
                @change="onRepresentativeSalesChange"
              >
                <el-option
                  v-for="sale in representativeSales"
                  :key="sale.id + 'repsale'"
                  :value="sale"
                  :label="sale.receipt_number"
                >
                  <span style="float: left; margin-right: 30px;">
                    {{ sale.receipt_number }} <i>(Képviselő: {{ sale.representative_name }}, Teljesítés: {{ sale.delivery_date | date }})</i>
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          v-if="!invoice.is_advance && advanceInvoices && advanceInvoices.length"
          style="margin-bottom: 30px;"
        >
          <h4 style="margin-top: 0">Előlegszámla hozzáadása</h4>
          <el-checkbox-group
            v-model="invoice.advance_invoices"
            size="small"
            @change="onAdvanceInvoiceChange"
          >
            <el-checkbox
              v-for="advanceInvoice in advanceInvoices"
              :key="advanceInvoice.id"
              :label="advanceInvoice.id"
              border
            >
              {{ advanceInvoice.invoice_number }} (nettó: {{ advanceInvoice.net_price | currency }})
            </el-checkbox>
          </el-checkbox-group>
        </el-row>
        <el-alert
          v-if="invoice.status === 'recorded'"
          title="Tételek ellenőrzése"
          type="warning"
          description="Lezárás előtt figyelmesen ellenőrízd végig a tételeket és az összegeket."
          show-icon
          style="margin-bottom: 20px;"
        />
        <p-table
          v-if="!invoice.is_advance"
          ref="productItems"
          style="margin-bottom: 20px;"
          v-for="sale in invoice.customer_sales"
          :key="sale.id + 'customersale'"
          :customer-id="invoice && invoice.customer && invoice.customer.id"
          :emptyLine="getEmptyLine('customerSale', sale.id)"
          :expandLines="[
            { label: 'Megjegyzés', prop: 'comment' },
            { label: 'EAN', prop: 'ean' },
          ]"
          :columns="columns"
          :opts="tableOptions"
          dialog="InvoiceItemDialog"
          :data="invoice.invoice_items && invoice.invoice_items.length && invoice.invoice_items.filter(item => item.customer_sale_id === sale.id)"
          :endpoint="!invoice.invoice_items || invoice.invoice_items.length === 0 ? `api/customer-sales/${sale.id}/items/invoice` : null"
          @change="onPriceChange"
        >
          <template>
            <div class="product-table-header">
              <div style="display: inline-block;">
                <strong>Szállítólevél: </strong>
                <receipt-link
                  :id="sale.id"
                  :label="sale.receipt_number"
                  type="customerSale"
                  style="margin: -4px 5px 0 5px;"
                />
                <i class="el-icon-d-arrow-right"></i> {{ sale.customer_name }} <i>(Teljesítés: {{ sale.delivery_date | date }})</i>
              </div>
              <div style="display: inline-block; float: right;">
                <el-button
                  v-if="type !== 'view'"
                  type="danger"
                  icon="el-icon-delete"
                  size="mini"
                  @click.stop.prevent="removeCustomerSale(sale.id)"
                  style="margin-top: -5px;"
                  :disabled="invoice.status !== 'recorded'"
                >
                  Szállítólevél törlése
                </el-button>
              </div>
            </div>
          </template>
        </p-table>
        <p-table
          v-if="!invoice.is_advance"
          ref="returnOrderItems"
          style="margin-bottom: 20px;"
          v-for="sale in invoice.customer_return_orders"
          :key="sale.id + 'customerreturnorder'"
          :customer-id="invoice && invoice.customer && invoice.customer.id"
          :emptyLine="getEmptyLine('customerReturnOrder', sale.id)"
          :expandLines="[
            { label: 'Megjegyzés', prop: 'comment' },
            { label: 'EAN', prop: 'ean' },
          ]"
          :columns="columns"
          :opts="tableOptions"
          dialog="InvoiceItemDialog"
          :data="invoice.invoice_items && invoice.invoice_items.length && invoice.invoice_items.filter(item => item.customer_return_order_id === sale.id)"
          :endpoint="!invoice.invoice_items || invoice.invoice_items.length === 0 ? `api/customer-return-orders/${sale.id}/items/invoice` : null"
          @change="onPriceChange"
        >
          <template>
            <div class="product-table-header">
              <div style="display: inline-block;">
                <strong>Szállítólevél: </strong>
                <receipt-link
                  :id="sale.id"
                  :label="sale.receipt_number"
                  type="customerSale"
                  style="margin: -4px 5px 0 5px;"
                />
                <i class="el-icon-d-arrow-right"></i> {{ sale.supplier_name }} <i>(Teljesítés: {{ sale.delivery_date | date }})</i>
              </div>
              <div style="display: inline-block; float: right;">
                <el-button
                  v-if="type !== 'view'"
                  type="danger"
                  icon="el-icon-delete"
                  size="mini"
                  @click.stop.prevent="removeCustomerReturnOrder(sale.id)"
                  style="margin-top: -5px;"
                  :disabled="invoice.status !== 'recorded'"
                >
                  Szállítólevél törlése
                </el-button>
              </div>
            </div>
          </template>
        </p-table>
        <p-table
          v-for="sale in invoice.representative_sales"
          :key="sale.id + 'repsale'"
          ref="representativeProductItems"
          :customer-id="invoice && invoice.customer && invoice.customer.id"
          style="margin-bottom: 20px;"
          :emptyLine="getEmptyLine('representativeSale', sale.id)"
          :expandLines="[
            { label: 'Megjegyzés', prop: 'comment' },
            { label: 'EAN', prop: 'ean' },
          ]"
          :columns="columns"
          :opts="tableOptions"
          dialog="InvoiceItemDialog"
          :data="invoice.invoice_items && invoice.invoice_items.length && invoice.invoice_items.filter(item => item.representative_sale_id === sale.id)"
          :endpoint="!invoice.invoice_items || invoice.invoice_items.length === 0 ? `api/representative-sales/${sale.id}/items/invoice` : null"
          @change="onPriceChange"
        >
          <template>
            <div class="product-table-header">
              <div style="display: inline-block;">
                <strong>Szállítólevél:</strong>
                <receipt-link
                  :id="sale.id"
                  :label="sale.receipt_number"
                  type="representativeSale"
                  style="margin: -4px 5px 0 5px;"
                />
                <i class="el-icon-d-arrow-right"></i> {{ sale.customer_name }} <i>(Teljesítés: {{ sale.delivery_date | date }})</i>
                <p style="margin-bottom: 0">Képviselő: {{ sale.representative_name }}</p>
              </div>
              <div style="display: inline-block; float: right;">
                <el-button
                  v-if="type !== 'view'"
                  type="danger"
                  icon="el-icon-delete"
                  size="mini"
                  @click.stop.prevent="removeRepresentativeSale(sale.id)"
                  style="margin-top: -5px;"
                  :disabled="invoice.status !== 'recorded'"
                >
                  Szállítólevél törlése
                </el-button>
              </div>
            </div>
          </template>
        </p-table>

        <p-table
          v-if="!loading"
          ref="productItemsWithoutSale"
          style="margin-bottom: 20px;"
          :customer-id="invoice && invoice.customer && invoice.customer.id"
          :emptyLine="getEmptyLine('withoutSale', null)"
          :expandLines="[
            { label: 'Megjegyzés', prop: 'comment' },
            { label: 'EAN', prop: 'ean' },
          ]"
          :columns="columns"
          :opts="noOrderTableOptions"
          dialog="InvoiceItemDialog"
          :endpoint="`api/invoices/${invoice.id}/no-delivery-items`"
          @change="onPriceChange"
        >
          <template>
            <div class="product-table-header">
              <div style="display: inline-block;">
                <strong>Szállítólevél nélküli tételek</strong>
              </div>
            </div>
          </template>
        </p-table>
      </el-form>
    </div>
    <div
      v-if="!loading"
      class="invoice-dialog-footer"
    >
      <div
        class="invoice-dialog-footer-info"
      >
        <div v-if="invoice.invoice_number">
          {{ invoice.invoice_number }}
        </div>
        <el-tag
          v-if="invoice.type === 'CREATE'"
          size="small"
          type="primary"
          style="margin-top: 5px; margin-right: 5px;"
        >
          Normál számla
        </el-tag>
        <el-tooltip
          v-if="invoice.type === 'MODIFY'"
          effect="dark"
          :content="`Módosítja a következőt: ${invoice.modified_invoice_number}`"
          placement="right"
        >
          <el-tag
            size="small"
            type="warning"
            style="margin-top: 5px; margin-right: 5px;"
          >
            Módosító okirat
          </el-tag>
        </el-tooltip>
        <el-tooltip
          v-if="invoice.type === 'STORNO'"
          effect="dark"
          :content="`Sztornózza a következőt: ${invoice.cancelled_invoice_number}`"
          placement="right"
        >
          <el-tag
            size="small"
            type="danger"
            style="margin-top: 5px; margin-right: 5px;"
          >
            Sztornó számla
          </el-tag>
        </el-tooltip>
        <el-tooltip
          v-if="invoice.status === 'cancelled'"
          effect="dark"
          :content="`Sztornózza a következő: ${invoice.cancel_invoice_number}`"
          placement="right"
        >
          <el-tag
            :type="getStatus().tag"
            size="small"
            style="margin-top: 5px;"
          >
            {{ getStatus().label }}
          </el-tag>
        </el-tooltip>
        <el-tooltip
          v-if="invoice.status === 'modified'"
          effect="dark"
          :content="`Módosítja a következő: ${invoice.modify_invoice_number}`"
          placement="right"
        >
          <el-tag
            :type="getStatus().tag"
            size="small"
            style="margin-top: 5px;"
          >
            {{ getStatus().label }}
          </el-tag>
        </el-tooltip>
        <el-tag
          v-if="invoice.status !== 'modified' && invoice.status !== 'cancelled'"
          :type="getStatus().tag"
          size="small"
          style="margin-top: 5px;"
        >
          {{ getStatus().label }}
        </el-tag>
      </div>
      <div
        class="invoice-dialog-footer-info-right"
      >
        <p>Nettó: <strong>{{ netSum | currency(invoice.currency.code) }}</strong></p>
        <p>Bruttó: <strong>{{ grossSum | currency(invoice.currency.code) }}</strong></p>
      </div>
      <el-button
        :disabled="invoice.status !== 'recorded' && !modificationEnabled || actionLoading"
        :loading="saveButtonLoading"
        type="success"
        icon="el-icon-check"
        @click="store(false, false, false, 'saveButtonLoading')"
      >
        Mentés
      </el-button>
      <el-button
        v-if="invoice.status === 'recorded'"
        :disabled="invoice.status !== 'recorded' && !modificationEnabled || actionLoading"
        :loading="closeButtonLoading"
        type="success"
        @click="store(true, false, false, 'closeButtonLoading')"
        icon="el-icon-lock"
      >
        Lezárás
      </el-button>
      <el-button
        v-if="invoice.status === 'recorded'"
        :disabled="invoice.status !== 'recorded' && !modificationEnabled || actionLoading"
        :loading="closeAndPrintLoading"
        type="success"
        icon="el-icon-lock"
        @click="store(true, true, true, 'closeAndPrintLoading')"
      >
        Lezárás & Nyomtatás
      </el-button>
      <el-button
        v-if="invoice.status === 'done' && invoice.type === 'CREATE' && (invoice.modify_invoice_id === null || (invoice.modify_invoice && invoice.modify_invoice.status === 'cancelled'))"
        :disabled="actionLoading"
        type="warning"
        icon="el-icon-edit"
        @click="flipModification"
      >
        <span v-if="modificationEnabled">Szerkesztés letiltása</span>
        <span
          v-if="!modificationEnabled"
        >
          Szerkesztés engedélyezése
        </span>
      </el-button>
      <el-button
        v-if="invoice.status === 'done' && invoice.type !== 'STORNO' && (invoice.modify_invoice_id === null || (invoice.modify_invoice && invoice.modify_invoice.status === 'cancelled'))"
        :disabled="actionLoading"
        :loading="stornoLoading"
        type="danger"
        icon="el-icon-circle-close"
        @click="stornoInvoice"
      >
        Sztornó
      </el-button>
      <el-button
        :disabled="invoice.status !== 'recorded' && !modificationEnabled || actionLoading"
        :loading="previewButtonLoading"
        icon="el-icon-view"
        @click="preview"
        v-if="invoice.status === 'recorded' && type !== 'add'"
      >
        Előnézet
      </el-button>
      <el-button
        :loading="printButtonLoading"
        :disabled="actionLoading"
        icon="el-icon-printer"
        @click="openInvoice"
        v-if="invoice.status !== 'recorded'"
      >
        Nyomtatás
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import moment from 'moment';
import rules from './rules';
import PTable from '../../utils/PTable';
import ReceiptLink from '../../utils/ReceiptLink';

export default {
  components: {
    ReceiptLink,
    PTable,
  },
  props: {
    type: {
      type: String,
      default() {
        return null;
      }
    },
    invoiceId: {
      type: Number,
      default() {
        return 0;
      }
    },
    partnerId: {
      type: Number,
      default() {
        return 0;
      }
    },
    saleIds: {
      type: Array,
      default() {
        return [];
      }
    },
    customerReturnOrderIds: {
      type: Array,
      default() {
        return [];
      }
    },
    representativeSaleIds: {
      type: Array,
      default() {
        return [];
      }
    },
    fallbackUrl: {
      type: String,
      default() {
        return '/sales/invoices';
      }
    }
  },
  data() {
    const today = moment()
      .format('Y-MM-DD');

    return {
      columns: [
        {
          label: 'Megnevezes',
          prop: 'product_name',
          minWidth: 200
        },
        {
          label: 'Beszállító',
          prop: 'supplier_name',
          showTooltip: true
        },
        {
          label: 'Mennyiség',
          prop: 'count',
          align: 'right'
        },
        {
          label: 'Kiszerelés',
          prop: 'unit_of_measure',
          format: 'unit',
          align: 'right'
        },
        {
          label: 'Egységár',
          prop: 'unit_price',
          align: 'right',
          format: 'currency'
        },
        {
          label: 'Nettó',
          prop: 'net_price',
          align: 'right',
          format: 'currency'
        },
        {
          label: 'Bruttó',
          prop: 'gross_price',
          align: 'right',
          format: 'currency'
        },
        {
          label: 'Áfa',
          prop: 'vat',
          align: 'right',
          format: 'percent'
        },
        {
          label: 'Áfa típus',
          prop: 'vat_label',
          align: 'right',
        },
      ],
      loading: false,
      stornoLoading: false,
      netSum: 0,
      grossSum: 0,
      saveButtonLoading: false,
      partnerLoading: false,
      customerSalesLoading: false,
      closeButtonLoading: false,
      printButtonLoading: false,
      previewButtonLoading: false,
      closeAndPrintLoading: false,
      actionLoading: false,
      addresses: [],
      hasDelivery: true,
      customers: [],
      netPrice: 0,
      grossPrice: 0,
      modificationEnabled: false,
      addressesLoading: false,
      customerSales: [],
      representativeSales: [],
      customPrices: [],
      advanceInvoices: [],
      customerReturnOrders: [],
      invoice: {
        is_advance: false,
        status: 'recorded',
        type: 'CREATE',
        net_price: 0,
        gross_price: 0,
        customer_sales: [],
        customer_return_orders: [],
        representative_sales: [],
        invoice_items: [],
        advance_invoices: [],
        customer: null,
        customer_address: null,
        invoice_book: null,
        supplier: {},
        issue_date: today,
        delivery_date: today,
        payment_date: today,
        payment_method: 'TRANSFER',
        currency: {},
      },
      formRules: {
        ...rules,
        exchange_rate: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (this.isHufInvoice || this.exchangeRate) {
                return callback();
              }
              callback(new Error('Nem forintos számlánál adja meg az árfolyamot.'));
            },
            // The localized input rounds its value on blur; validating earlier would see the raw text.
            trigger: 'blur'
          }
        ],
      },
    };
  },
  computed: {
    isHufInvoice() {
      return !this.invoice.currency || !this.invoice.currency.code || this.invoice.currency.code === 'HUF';
    },
    exchangeRate: {
      // On a non-HUF invoice the stored default 1 (a number from the API) means the exchange rate was never
      // given. The input emits strings, so a typed "1" on its way to e.g. "15,5" is not mistaken for it.
      get() {
        if (this.isHufInvoice || !this.invoice.exchange_rate || this.invoice.exchange_rate === 1) {
          return undefined;
        }
        return this.invoice.exchange_rate;
      },
      set(value) {
        this.$set(this.invoice, 'exchange_rate', value);
      },
    },
    tableOptions() {
      return {
        currency: this.invoice && this.invoice.currency && this.invoice.currency.code || 'HUF',
        addItem: this.modificationEnabled,
        updateItem: this.modificationEnabled || this.invoice.status === 'recorded',
        deleteItem: this.modificationEnabled,
        editableFields: [],
      };
    },
    noOrderTableOptions() {
      return {
        currency: this.invoice && this.invoice.currency && this.invoice.currency.code || 'HUF',
        addItem: this.modificationEnabled || this.invoice.status === 'recorded',
        updateItem: this.modificationEnabled || this.invoice.status === 'recorded',
        deleteItem: this.modificationEnabled || this.invoice.status === 'recorded',
        editableFields: [],
      };
    },
    suppliers() {
      return this.$store.getters['ownCompany/ownCompanies'];
    },
    invoiceBooks() {
      return this.$store.getters['invoiceBook/invoiceBooks'];
    },
    currencies() {
      return this.$store.getters['currency/currencies'];
    },
  },
  async mounted() {
    window.addEventListener('force-edit-invoice', () => {
        this.modificationEnabled = true
    })

    this.loading = true;
    const requests = [];
    if (!this.currencies || !this.currencies.length) {
      requests.push(this.$store.dispatch('currency/fetchAll'));
    }
    if (!this.invoiceBooks || !this.invoiceBooks.length) {
      requests.push(this.$store.dispatch('invoiceBook/fetchAll', ''));
    }
    if (!this.suppliers || !this.suppliers.length) {
      requests.push(this.$store.dispatch('ownCompany/fetchAll'));
    }
    await Promise.all(requests);
    this.customers = await this.$store.dispatch('partner/fetchCustomersWithBillable');
    if (this.invoiceId) {
      this.hasDelivery = false;
      this.invoice = await this.$store.dispatch('invoice/fetch', this.invoiceId);
      this.netSum = this.invoice.net_price;
      this.grossSum = this.invoice.gross_price;

      this.customPrices = await axios.get(`api/customer-price-lists/partner/${this.invoice.customer.id}`);

      this.customers.push(this.invoice.customer);

      this.customerSalesLoading = true;
      try {
        this.customerSales = await axios.get('api/customer-sales/billable/' + this.invoice.customer.id);
        this.customerReturnOrders = await axios.get('api/customer-return-orders/billable/' + this.invoice.customer.id);
        this.representativeSales = await axios.get('api/representative-sales/billable/' + this.invoice.customer.id);
        this.advanceInvoices = await axios.get(`api/invoices/advance/partner/${this.invoice.customer.id}/${this.invoiceId}`);
        this.invoice.advance_invoices = this.advanceInvoices.filter(adv => adv.final_invoice_id === this.invoiceId).map(adv => adv.id);
      } catch (e) {
      }
      this.customerSalesLoading = false;

      if (this.invoice.customer_sales && this.invoice.customer_sales.length) {
        this.customerSales.push(...this.invoice.customer_sales);
      }
      if (this.invoice.customer_return_orders && this.invoice.customer_return_orders.length) {
        this.customerReturnOrders.push(...this.invoice.customer_return_orders);
      }
      if (this.invoice.representative_sales && this.invoice.representative_sales.length) {
        this.representativeSales.push(...this.invoice.representative_sales);
      }

      this.addresses = this.invoice.customer.company.addresses.filter(a => a.pivot.type === 'billing');
    } else {

      let partnerId = this.partnerId;
      let saleIds = this.saleIds;
      let representativeSaleIds = this.representativeSaleIds;

      if (this.type === 'add') {
        if (this.$route.query.hasOwnProperty('partnerId')) {
          partnerId = this.$route.query.partnerId;
        }

        if(this.$route.query.hasOwnProperty('saleIds')) {
          saleIds = this.$route.query.saleIds.map(Number);
        }

        if(this.$route.query.hasOwnProperty('representativeSaleIds')) {
          representativeSaleIds = this.$route.query.representativeSaleIds.map(Number);
        }
      }

      this.invoice.supplier = this.suppliers[0];
      this.invoice.currency = this.currencies[0];
      if (partnerId) {
        this.invoice.customer = await axios.get(`api/partners/customers/${partnerId}/invoice`);
        this.onCustomerChange();
        this.onCustomerSalesChange(this.invoice.customer && this.invoice.customer.customer_sales && this.invoice.customer.customer_sales.filter(cs => saleIds.includes(cs.id)));
        if (this.invoice.customer && this.invoice.customer.customer_return_orders) {
          this.onCustomerReturnOrdersChange(this.invoice.customer && this.invoice.customer.customer_return_orders.filter(cs => this.customerReturnOrderIds.includes(cs.id)));
        }
        this.onRepresentativeSalesChange(this.invoice.customer && this.invoice.customer.representative_sales && this.invoice.customer.representative_sales.filter(cs => representativeSaleIds.includes(cs.id)));
      }
    }
    if (this.type === 'add') {
      this.invoice.invoice_book = this.$store.getters['invoiceBook/lastSelected'];
    }
    this.loading = false;
    console.log(this.invoice)
  },
  methods: {
    async stornoInvoice() {
      this.stornoLoading = true;
      try {
        const response = await this.$store.dispatch('invoice/storno', this.invoice.id);
        this.invoice = response.data;
        this.$router.replace('/sales/invoices/update/' + response.data.id);
        setTimeout(() => {
          if (this.$refs['productItems']) {
            this.$refs['productItems'].forEach(productItemRef => productItemRef.loadItems());
          }
          if (this.$refs['representativeProductItems']) {
            this.$refs['representativeProductItems'].forEach(productItemRef => productItemRef.loadItems());
          }
          if (this.$refs['productItemsWithoutSale']) {
            this.$refs['productItemsWithoutSale'].loadItems();
          }
        }, 100);
      } catch (e) {
      }
      this.$store.dispatch('invoice/fetchAll');
      this.$store.dispatch('partner/fetchCustomersWithBillableWithPagination', {
        currentPage: 1,
        sorting: {
          prop: 'company.name',
          order: 'ascending'
        }
      });
      this.stornoLoading = false;
    },
    onAdvanceInvoiceChange(value) {
      const items = this.$refs['productItemsWithoutSale'].getItems();
      items.forEach(item => {
        if (item.is_advance_item || item.final_invoice_id) {
          this.$refs['productItemsWithoutSale'].removeItem(item);
        }
      })
      value.forEach(advanceInvoiceId => {
        const advanceInvoice = this.advanceInvoices.find(inv => inv.id === advanceInvoiceId);
        const advanceItem = this.getEmptyLine();
        advanceItem.is_advance_item = true;
        advanceItem.advance_invoice_id = advanceInvoiceId;
        advanceItem.unit_price = -1 * advanceInvoice.net_price;
        advanceItem.net_price = -1 * advanceInvoice.net_price;
        advanceItem.gross_price = -1 * advanceInvoice.gross_price;
        advanceItem.vat_value = advanceItem.gross_price - advanceItem.net_price;
        advanceItem.vat = Math.round((advanceInvoice.gross_price / advanceInvoice.net_price - 1) * 100);
        advanceItem.count = 1;
        advanceItem.product_name = `Előleg: ${advanceInvoice.invoice_number}`;
        this.$refs['productItemsWithoutSale'].createItem(advanceItem)
      })
      this.onPriceChange();
    },
    onIsAdvanceChange(value) {
      this.invoice.invoice_items = [];
      this.invoice.customer_sales = [];
      this.invoice.representative_sales = [];
      if (value) {
        this.$refs['productItemsWithoutSale'].createItem({
          count: 1,
          unit_price: 0,
          net_price: 0,
          count_per_pack: 1,
          vat: 27,
          expiration_date: null,
          comment: '',
          product_name: 'Előleg',
          unit_of_measure: 'PIECE',
          product_code_category: '',
          product_code_value: '',
          invoice_id: this.invoice.id,
          product_pack_type_id: null,
          product_id: null,
          supplier_id: null,
          customer_sale_id: null,
          representative_sale_id: null,
          service_id: null,
          vat_value: 0,
          gross_price: 0,
          supplier_name: null,
        });
      } else {
        this.$refs['productItemsWithoutSale'].clear();
      }
    },
    flipModification() {
      this.modificationEnabled = !this.modificationEnabled;
    },
    getKey() {
      return Math.random()
        .toString(36)
        .substring(7);
    },
    async searchPartners(query) {
      this.partnerLoading = true;
      if (!query) {
        this.partners = [];
      } else {
        const queryString = new URLSearchParams({
          name: query,
        });
        this.customers = await axios.get('api/partners/customers/invoice' + '?' + queryString.toString());
      }
      this.partnerLoading = false;
    },
    removeCustomerSale(id) {
      this.invoice.invoice_items = this.invoice.invoice_items.filter(item => item.customer_sale_id !== id);
      this.invoice.customer_sales = this.invoice.customer_sales.filter(sale => sale.id !== id);
      this.onPriceChange();
    },
    removeCustomerReturnOrder(id) {
      this.invoice.invoice_items = this.invoice.invoice_items.filter(item => item.customer_return_order_id !== id);
      this.invoice.customer_return_orders = this.invoice.customer_return_orders.filter(sale => sale.id !== id);
      this.onPriceChange();
    },
    removeRepresentativeSale(id) {
      this.invoice.invoice_items = this.invoice.invoice_items.filter(item => item.representative_sale_id !== id);
      this.invoice.representative_sales = this.invoice.representative_sales.filter(sale => sale.id !== id);
      this.onPriceChange();
    },
    onCustomerSalesChange(selectedSales) {
      let newSale = null;
      selectedSales.forEach(sale => {
        if (!this.invoice.customer_sales.find(s => s.id === sale.id)) {
          this.invoice.delivery_date = sale.delivery_date;
          newSale = sale;
        }
        if (newSale) {
          this.invoice.customer_sales.push(newSale);
        }
      });
      this.invoice.customer_sales.forEach(sale => {
        if (!selectedSales.find(s => s.id === sale.id)) {
          this.removeCustomerSale(sale.id);
        }
      });
      this.onPriceChange();
    },
    onCustomerReturnOrdersChange(selectedSales) {
      let newSale = null;
      selectedSales.forEach(sale => {
        if (!this.invoice.customer_return_orders.find(s => s.id === sale.id)) {
          this.invoice.delivery_date = sale.delivery_date;
          newSale = sale;
        }
        if (newSale) {
          this.invoice.customer_return_orders.push(newSale);
        }
      });
      this.invoice.customer_return_orders.forEach(sale => {
        if (!selectedSales.find(s => s.id === sale.id)) {
          this.removeCustomerReturnOrder(sale.id);
        }
      });
      this.onPriceChange();
    },
    onRepresentativeSalesChange(selectedSales) {
      let newSale = null;
      selectedSales.forEach(sale => {
        if (!this.invoice.representative_sales.find(s => s.id === sale.id)) {
          this.invoice.delivery_date = sale.delivery_date;
          newSale = sale;
        }
        if (newSale) {
          this.invoice.representative_sales.push(newSale);
        }
      });
      this.invoice.representative_sales.forEach(sale => {
        if (!selectedSales.find(s => s.id === sale.id)) {
          this.removeRepresentativeSale(sale.id);
        }
      });
    },
    validateCustomerAddress() {
      const missingInformation = [];
      if (!this.invoice.customer_address.city) {
        missingInformation.push('city');
      }
      if (!this.invoice.customer_address.postal_code) {
        missingInformation.push('postal_code');
      }
      if (!this.invoice.customer_address.address) {
        missingInformation.push('address');
      }
      return missingInformation;
    },
    onHasDelivery() {
      this.invoice.invoice_items = [];
      this.invoice.customer_sales = [];
      this.invoice.customer = {};
      this.invoice.customer_address = {};
      this.addresses = [];
    },
    onCurrencyChange() {
      this.exchangeRate = undefined;
    },
    async onCustomerChange() {
      this.addressesLoading = true;
      this.customerSalesLoading = true;
      const requests = [];
      requests.push(axios.get(`api/addresses/company/${this.invoice.customer.company.id}/billing`))
      this.$set(this.invoice, 'payment_date', moment()
        .add('days', this.invoice.customer.company.payment_deadline)
        .format('Y-MM-DD'));
      this.$refs['invoiceForm'].clearValidate('customer_address');
      this.invoice.invoice_items = [];
      this.invoice.customer_sales = [];
      this.invoice.customer_return_orders = [];
      this.invoice.representative_sales = [];
      requests.push(axios.get(`api/customer-price-lists/partner/${this.invoice.customer.id}`))
      try {
        requests.push(axios.get('api/customer-sales/billable/' + this.invoice.customer.id))
        requests.push(axios.get('api/representative-sales/billable/' + this.invoice.customer.id))
        if (this.invoice.id) {
          requests.push(axios.get(`api/invoices/advance/partner/${this.invoice.customer.id}/${this.invoice.id}`))
        } else {
          requests.push(axios.get(`api/invoices/advance/partner/${this.invoice.customer.id}`))
        }
        requests.push(axios.get('api/customer-return-orders/billable/' + this.invoice.customer.id))

        const [addresses, customPrices, customerSales, representativeSales, advanceInvoices, customerReturnOrders] = await Promise.all(requests);
        this.addresses = addresses;
        this.customPrices = customPrices;
        this.customerSales = customerSales;
        this.representativeSales = representativeSales;
        this.advanceInvoices = advanceInvoices;
        this.customerReturnOrders = customerReturnOrders;

        if (this.addresses) {
          this.invoice.customer_address = JSON.parse(JSON.stringify(this.addresses[0]));
        }
      } catch (e) {
      }
      this.addressesLoading = false;
      this.customerSalesLoading = false;
    },
    onPriceChange() {
      let netSum = 0;
      let grossSum = 0;
      if (this.$refs['productItems']) {
        this.$refs['productItems'].forEach(productItemForm => {
          const { netPrice, grossPrice } = productItemForm.getPrices();
          netSum += netPrice;
          grossSum += grossPrice;
        });
      }
      if (this.$refs['returnOrderItems']) {
        this.$refs['returnOrderItems'].forEach(productItemForm => {
          const { netPrice, grossPrice } = productItemForm.getPrices();
          netSum += netPrice;
          grossSum += grossPrice;
        });
      }
      if (this.$refs['representativeProductItems']) {
        this.$refs['representativeProductItems'].forEach(productItemForm => {
          const { netPrice, grossPrice } = productItemForm.getPrices();
          netSum += netPrice;
          grossSum += grossPrice;
        });
      }
      if (this.$refs['productItemsWithoutSale']) {
        const { netPrice, grossPrice } = this.$refs['productItemsWithoutSale'].getPrices();
        netSum += netPrice;
        grossSum += grossPrice;
      }
      this.netSum = netSum;
      this.grossSum = grossSum.toFixed(2);
    },
    onInvoiceBookChange(val) {
      this.$store.commit('invoiceBook/setLastSelected', val);
    },
    handleClose() {
      if (this.type === 'view') {
        this.$router.replace(this.fallbackUrl);
        return this.$emit('close');
      }
      this.$confirm('Biztosan elveted a módosításokat?', {
        confirmButtonText: 'Igen',
        type: 'warning',
      })
        .then(() => {
          this.$router.replace(this.fallbackUrl);
          this.$emit('close');
        })
        .catch(() => {
        });
    },
    // The server only needs ids from these relations; sending the loaded objects bloats the request.
    getPayload() {
      const onlyId = list => (list || []).map(({ id }) => ({ id }));
      return {
        ...this.invoice,
        exchange_rate: this.exchangeRate === undefined ? null : this.exchangeRate,
        customer: { id: this.invoice.customer.id },
        customer_sales: onlyId(this.invoice.customer_sales),
        customer_return_orders: onlyId(this.invoice.customer_return_orders),
        representative_sales: onlyId(this.invoice.representative_sales),
      };
    },
    async store(close = false, print = false, closeDialog = false, buttonLoading = 'saveButtonLoading') {
      this.modificationEnabled = false;
      this.$refs.invoiceForm.validate(async valid => {
        this.actionLoading = true;
        this[buttonLoading] = true;
        if (valid) {
          if (this.validateCustomerAddress().length) {
            return this.$messageWrapper.error('A vevő címe hibásan van megadva.');
          }
          const items = [];
          if (this.$refs['productItems']) {
            let hasError = false;
            this.$refs['productItems'].forEach(productItems => {
              // if (productItems.validateProducts()) {
              items.push(...(productItems.getItems()));
              // } else {
              //   hasError = true;
              // }
            });
            if (hasError) {
              return this.$messageWrapper.error('Hibásan kitöltött számlatétel.');
            }
          }
          if (this.$refs['returnOrderItems']) {
            let hasError = false;
            this.$refs['returnOrderItems'].forEach(productItems => {
              // if (productItems.validateProducts()) {
              items.push(...(productItems.getItems()));
              // } else {
              //   hasError = true;
              // }
            });
            if (hasError) {
              return this.$messageWrapper.error('Hibásan kitöltött számlatétel.');
            }
          }
          if (this.$refs['representativeProductItems']) {
            let hasError = false;
            this.$refs['representativeProductItems'].forEach(productItems => {
              // if (productItems.validateProducts()) {
              items.push(...(productItems.getItems()));
              // } else {
              //   hasError = true;
              // }
            });
            if (hasError) {
              return this.$messageWrapper.error('Hibásan kitöltött számlatétel.');
            }
          }
          if (this.$refs['productItemsWithoutSale']) {
            // if (this.$refs['productItemsWithoutSale'].validateProducts()) {
            items.push(...(this.$refs['productItemsWithoutSale'].getItems()));
            // } else {
            //   return this.$messageWrapper.error('Hibásan kitöltött számlatétel.');
            // }
          }
          this.invoice.invoice_items = items;
          if (!this.invoice.invoice_items.length) {
            return this.$messageWrapper.warning('Minimum 1 termék hozzáadása kötelező.');
          }
          try {
            this.invoice.shouldClose = close;
            if (this.type === 'add') {
              const response = await this.$store.dispatch('invoice/create', this.getPayload());
              this.invoice = response.data;
              this.$router.replace('/sales/invoices/update/' + response.data.id);
            } else if (this.type === 'update') {
              const response = await this.$store.dispatch('invoice/update', this.getPayload());
              this.invoice = response.data;
              this.$router.replace('/sales/invoices/update/' + response.data.id);
            }
            if (print) {
              await this.openInvoice();
            }
            if (closeDialog) {
              this.$router.replace('/sales/invoices');
            }
            setTimeout(() => {
              if (this.$refs['productItems']) {
                this.$refs['productItems'].forEach(productItemRef => productItemRef.loadItems());
              }
              if (this.$refs['returnOrderItems']) {
                this.$refs['returnOrderItems'].forEach(productItemRef => productItemRef.loadItems());
              }
              if (this.$refs['representativeProductItems']) {
                this.$refs['representativeProductItems'].forEach(productItemRef => productItemRef.loadItems());
              }
              if (this.$refs['productItemsWithoutSale']) {
                this.$refs['productItemsWithoutSale'].loadItems();
              }
            }, 100);
            this.$store.dispatch('invoice/fetchAll');
            this.$store.dispatch('partner/fetchCustomersWithBillableWithPagination', {
              currentPage: 1,
              sorting: {
                prop: 'company.name',
                order: 'ascending'
              }
            });
          } catch (e) {
          }
        }
        this.actionLoading = false;
        this[buttonLoading] = false;
      });
    },
    openReceipt() {
      if (this.invoice.receipt_file && this.invoice.receipt_file.path) {
        window.open(this.invoice.receipt_file.path);
      }
    },
    async openInvoice() {
      this.printButtonLoading = true;
      const response = await axios.get(`api/receipts/invoice/${this.invoice.id}`, {
        responseType: 'arraybuffer',
        headers: {
          'Accept': 'application/pdf'
        },
      });

      const newBlob = new Blob([response], { type: 'application/pdf' });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      const data = window.URL.createObjectURL(newBlob);
      window.open(data);
      this.printButtonLoading = false;
    },
    getStatus() {
      switch (this.invoice.status) {
        case 'recorded':
          return {
            label: 'Rögzítve',
            tag: 'info',
          };
        case 'done':
          return {
            label: 'Lezárva',
            tag: 'success',
          };
        case 'cancelled':
          return {
            label: 'Sztornózva',
            tag: 'danger',
          };
        case 'modified':
          return {
            label: 'Módosítva',
            tag: 'warning',
          };
      }
    },

    async closeInvoice() {
      this.closeButtonLoading = true;
      try {
        const response = await this.$store.dispatch('invoice/close', this.invoice.id);
        this.invoice = response.data;
        this.$router.replace('/sales/invoices/update/' + response.data.id);
        this.$store.dispatch('invoice/fetchAll');
      } catch (e) {
      }
      this.closeButtonLoading = false;
    },

    async preview() {
      this.previewButtonLoading = true;
      await this.store(false, false, false, 'saveButtonLoading')
      const response = await axios.get('api/invoices/preview/' + this.invoiceId, {
        responseType: 'arraybuffer',
        headers: {
          'Accept': 'application/pdf'
        },
      });
      this.previewButtonLoading = false;

      const newBlob = new Blob([response], { type: 'application/pdf' });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      const data = window.URL.createObjectURL(newBlob);
      window.open(data);
    },

    getEmptyLine(type, saleId) {
      return {
        count: 1,
        unit_price: 0,
        net_price: 0,
        count_per_pack: 1,
        vat: 27,
        expiration_date: null,
        comment: '',
        product_name: '',
        unit_of_measure: 'PIECE',
        product_code_category: '',
        product_code_value: '',
        invoice_id: this.invoice.id,
        product_pack_type_id: null,
        product_id: null,
        supplier_id: null,
        customer_sale_id: type === 'customerSale' ? saleId : null,
        customer_return_order_id: type === 'customerReturnOrder' ? saleId : null,
        representative_sale_id: type === 'representativeSale' ? saleId : null,
        service_id: null,
        vat_value: 0,
        gross_price: 0,
        supplier_name: null,
        ean: null,
      };
    },
  },
};
</script>

<style lang="scss">
  .invoice-dialog-footer {
    width: calc(100% - 40px);
    position: fixed;
    text-align: center;
    bottom: 0px;
    left: 0px;
    background: white;
    box-shadow: 0 8px 10px -5px rgba(0, 0, 0, 0.2), 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12);
    padding: 20px;
    border-top: 1px solid #d7dae2;
    z-index: 9999;

    .invoice-dialog-footer-info {
      position: absolute;
      text-align: left;
    }

    .invoice-dialog-footer-info-right {
      position: absolute;
      right: 20px;
      text-align: right;

      p {
        line-height: 1.2;
        margin: 5px 0;
      }
    }
  }

  .price-sum {
    margin-top: 20px;
    text-align: right;
    font-size: 18px;

    > div {
      display: inline-block;
    }
  }

  .product-table-header {
    border-top: 1px dotted #dadfe7;
  }

  .product-table-header {
    border-left: 1px dotted #dadfe7;
    border-right: 1px dotted #dadfe7;
    padding: 15px 10px;
  }
</style>
